/**
 * 订阅提交器：点击「Claim my weekly ranking」时调用后端保存。
 *
 * 当前后端 `AddPreferenceRequest.subscribed_scenes` 为 Map：
 * key=订阅场景（AgentConstants.SubscribedScene，本期仅 WEEKLY_THEME_RANKING），
 * value=接收邮箱 —— 一次 POST 同时保存场景与邮箱（按 key 幂等合并，同场景重复提交以新邮箱覆盖）。
 */

import type { MemberClient } from "@features/api/memberApi";

export type SubscribeEmailSubmitter = (email: string) => Promise<boolean>;

let submitter: SubscribeEmailSubmitter = async () => {
  // 未注册（无 API client 环境）时视为成功，保证弹窗流程可走通（dev 兜底）
  return true;
};

/** 注册真实提交器（OspApiClientProvider 启动时调用） */
export function setSubscribeEmailSubmitter(fn: SubscribeEmailSubmitter): void {
  submitter = fn;
}

export function submitSubscribeEmail(email: string): Promise<boolean> {
  return submitter(email);
}

export function createSubscribeEmailSubmitter(
  memberApi?: MemberClient<any>,
): SubscribeEmailSubmitter {
  return async (email: string) => {
    if (!memberApi) {
      return true;
    }
    try {
      // Map 结构：key=订阅场景，value=接收邮箱（后端按 key 幂等合并，重复提交同场景以新邮箱覆盖）
      const response = await memberApi.agents.addPreference({
        subscribed_scenes: { WEEKLY_THEME_RANKING: email },
      });
      return response?.data?.code === undefined || response?.data?.code === 0;
    } catch {
      return false;
    }
  };
}
